import { render } from "./ImprestIndex.vue?vue&type=template&id=73272bca"
import script from "./ImprestIndex.vue?vue&type=script&lang=js"
export * from "./ImprestIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__